// Hardcoded user for bypass authentication
const HARDCODED_USER = {
  email: 'christian@samxlabs.co',
  displayName: 'Test User - SamXLabs',
  photoURL: 'https://via.placeholder.com/150',
  accessToken: 'hardcoded-token',
  role: 'admin'
};

const initialState = {
  userInfo: HARDCODED_USER,
  loading: false,
  errorLogin: '',
  isAuthenticated: true
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'auth/loginUser':
      return {
        ...state,
        userInfo: {
          email: action.payload.user.email,
          displayName: action.payload.user.displayName,
          photoURL: action.payload.user.photoURL,
          accessToken: action.payload.user?.Aa,
          role: action.payload.role
        },
        loading: false,
        isAuthenticated: true
      };
    case 'auth/loginPending':
      return {
        ...state,
        loading: true,
        isAuthenticated: false
      };
    case 'auth/loginError':
      return {
        userInfo: null,
        loading: false,
        errorLogin: action.payload.error,
        isAuthenticated: false
      };
    case 'auth/validateUserAuth':
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          email: action.payload.user.email,
          displayName: action.payload.user.displayName,
          photoURL: action.payload.user.photoURL,
          accessToken: action.payload.idToken
        },
        isAuthenticated: true
      };
    case 'auth/logoutUser':
      return initialState;
    default:
      return state;
  }
};
